/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

/* ==========================================================================
   FIX CARRITO MOVIL (app Section Store - section-store--cart-block)
   En iPhone la lista de productos del carrito (.cart-body, dentro del
   shadow DOM de la app) no se deslizaba con el dedo. Este respaldo:
   - Detecta el deslizamiento dentro del carrito.
   - Si el navegador NO movio la lista por si solo, la mueve siguiendo el
     dedo (con inercia). Si el navegador si la mueve, no hace nada.
   ========================================================================== */
(function () {
  var HOST_SEL = 'section-store--cart-block';

  function getBody(host) {
    var sr = host && host.shadowRoot;
    return sr ? sr.querySelector('.cart-body') : null;
  }

  function attach(host) {
    if (!host || host.__holixScrollFix || !host.shadowRoot) return;
    host.__holixScrollFix = true;
    var sr = host.shadowRoot;

    // CSS de apoyo dentro del shadow DOM
    try {
      var st = document.createElement('style');
      st.textContent =
        '.cart-body{-webkit-overflow-scrolling:touch;touch-action:pan-y;min-height:0;}' +
        '.cart-body *{touch-action:pan-y;}';
      sr.appendChild(st);
    } catch (e) {}

    var body = null, startY = 0, lastY = 0, lastT = 0, startScroll = 0;
    var velocity = 0, manual = false, tracking = false, raf = null;

    function stopMomentum() { if (raf) { cancelAnimationFrame(raf); raf = null; } }

    sr.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { tracking = false; return; }
      var path = e.composedPath ? e.composedPath() : [];
      body = getBody(host);
      if (!body || path.indexOf(body) === -1) { tracking = false; return; }
      if (body.scrollHeight <= body.clientHeight + 1) { tracking = false; return; }
      stopMomentum();
      tracking = true; manual = false; velocity = 0;
      startY = lastY = e.touches[0].clientY;
      lastT = Date.now();
      startScroll = body.scrollTop;
    }, { passive: true });

    sr.addEventListener('touchmove', function (e) {
      if (!tracking || !body || e.touches.length !== 1) return;
      var y = e.touches[0].clientY;
      var now = Date.now();
      var dy = y - lastY;
      var dt = Math.max(1, now - lastT);

      if (!manual) {
        var moved = Math.abs(y - startY);
        var nativeScrolled = Math.abs(body.scrollTop - startScroll) > 1;
        if (moved > 8 && !nativeScrolled) manual = true; // iOS no esta deslizando: tomamos el control
      }
      if (manual) {
        body.scrollTop -= dy;
        velocity = dy / dt; // px por ms
      }
      lastY = y; lastT = now;
    }, { passive: true });

    function endTouch() {
      if (!tracking) return;
      tracking = false;
      if (!manual || !body) return;
      var v = velocity * 16; // px por frame
      if (Math.abs(v) < 0.5) return;
      (function step() {
        body.scrollTop -= v;
        v *= 0.94;
        if (Math.abs(v) > 0.5) raf = requestAnimationFrame(step); else raf = null;
      })();
    }
    sr.addEventListener('touchend', endTouch, { passive: true });
    sr.addEventListener('touchcancel', endTouch, { passive: true });
  }

  function scan() {
    var hosts = document.querySelectorAll(HOST_SEL);
    for (var i = 0; i < hosts.length; i++) attach(hosts[i]);
  }

  function start() {
    scan();
    // la app crea/recrea el carrito despues de cargar; revisamos cada segundo (es muy ligero)
    setInterval(scan, 1000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
